export enum ActionStatus {
    WaitingForConfirmation,
    InProgress,
    Completed,
    Failed
}
